import React from "react";

interface IconProps {
  width?: string;
  height?: string;
  color?: string;
  fillColor?: string;
}

const IconMarketing: React.FC<IconProps> = ({
  width = "41",
  height = "40",
  color = "#EE8113",
  fillColor = "white",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20.5" cy="20" r="19" fill={fillColor} stroke={color} strokeWidth="2" />
    <path d="M27.14,20.75H21.82v9h5.32a.7.7,0,0,0,.7-.71V21.46A.7.7,0,0,0,27.14,20.75Z" fill={color} />
    <path d="M13.16,21.46V29a.7.7,0,0,0,.7.71h5.32v-9H13.86A.7.7,0,0,0,13.16,21.46Z" fill={color} />
    <path d="M12.2,17v2.21a.7.7,0,0,0,.7.7h6.28V16.3H12.9A.7.7,0,0,0,12.2,17Z" fill={color} />
    <path d="M28.1,16.3H21.8l0,3.61H28.1a.7.7,0,0,0,.7-.7V17A.7.7,0,0,0,28.1,16.3Z" fill={color} />
    <path 
      d="M15.11,15.5a1.05,1.05,0,0,0,.59.12h9.51a1.23,1.23,0,0,0,.66-.13,2.38,2.38,0,0,0,1-2.14,3.45,3.45,0,0,0-.64-2,2.54,2.54,0,0,0-2.08-1H24c-2.21.15-3.12,2.26-3.47,3.62-.35-1.36-1.25-3.47-3.47-3.62H16.8a2.55,2.55,0,0,0-2.09,1,3.45,3.45,0,0,0-.64,2A2.37,2.37,0,0,0,15.11,15.5Z"
      fill={color}
    />
  </svg>
);

export default IconMarketing;
